import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'

import { createDocumentForm } from '~/store/actions/documents'
import type { Document } from '~/types'

import { DocumentDetailsNew } from './DocumentDetailsNew'
import { removeIdsFromDocument } from './utils'

interface DocumentDetailsLocationState {
  state: {
    newDocument: Document
  }
}

interface DocumentCreationProps {
  onClose: () => void
}

export const DocumentCreation = ({ onClose }: DocumentCreationProps) => {
  const location = useLocation() as DocumentDetailsLocationState
  const dispatch = useDispatch()

  const { t } = useTranslation('Common')

  const { newDocument } = location.state || {}
  // eslint-disable-next-line react/hook-use-state
  const [document] = useState(newDocument)
  const [hasUnsavedData, setHasUnsavedData] = useState(true)
  if (!document) return null

  const handleSave = (doc: Document) => {
    // Remove IDs from document elements and their options when creating a new document
    // to prevent "detached entity passed to persist" errors
    const updatedDocument = removeIdsFromDocument(doc)

    setHasUnsavedData(false)
    dispatch(createDocumentForm(updatedDocument))
  }
  return (
    <DocumentDetailsNew
      disableClone
      disableDelete
      document={document}
      hasUnsavedData={hasUnsavedData}
      saveButtonLabel={t('Common:CREATE_FORM')}
      onClose={onClose}
      onSave={handleSave}
    />
  )
}
